export default __webpack_public_path__ + "static/media/icon-dropdown.e4ffbb49.svg";